import { Button, HStack, IconButton } from '@hover/blueprint';
import { iconArrowLeft, iconArrowRight } from '@hover/icons';
import React from 'react';

import { TranslationNamespace, useTranslate } from 'src/shared/hooks';
import type { ScrollDirection } from 'src/shared/hooks/scrollHooks/useScrollTo';

interface FooterProps {
  atLeft: boolean;
  atRight: boolean;
  scroll: (direction: ScrollDirection) => void;
  onClose?: () => void;
}

export const Footer = ({ atLeft, atRight, onClose, scroll }: FooterProps) => {
  const t = useTranslate(TranslationNamespace.HOMEOWNER_APP);

  return (
    <>
      {onClose && (
        <Button
          display={{ tablet: 'none' }}
          onClick={onClose}
          size="large"
          width="100%"
        >
          {t('palette.cancel')}
        </Button>
      )}
      <HStack display={{ base: 'none', tablet: 'flex' }} gap={400}>
        <IconButton
          icon={iconArrowLeft}
          isDisabled={atLeft}
          key="scroll-start"
          label={t('selector.scrollLeft')}
          onClick={() => scroll('left')}
          size="large"
          variant="ghost"
        />
        <IconButton
          icon={iconArrowRight}
          isDisabled={atRight}
          key="scroll-end"
          label={t('selector.scrollRight')}
          onClick={() => scroll('right')}
          size="large"
          variant="ghost"
        />
      </HStack>
    </>
  );
};
